import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from '@reduxjs/toolkit/query';
import authReducer from "./AuthSlice/authSlice";
import { authApi } from "../services/authApi";
import joyceSlice  from "./JoyiceSlice/joyiceSlice";




export const store = configureStore({
     // ? Add the authReducer to the reducer object
     reducer: {
     joyceState: joyceSlice,
     authState: authReducer,
     [authApi.reducerPath]: authApi.reducer
     },
    // devTools: import.meta.env.NODE_ENV !== "production",
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({}).concat(authApi.middleware)});

  // optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);